//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TocIndex from 'components/blocks/TocIndex.vue'

export default {
  props: ['data','sharedData'],
  methods: {
    changeSubSection(index) {
      if(this.data.paging) {
        this.sharedData.currentSubSection = index;
      } else {
        this.sharedData.scrollingPosition = index;
      }
    },
  },
  components: {
    TocIndex
  },

}



// WEBPACK FOOTER //
// ./components/combinedBlocks/Toc.vue